import React from 'react'
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

import LoginIcon from '@mui/icons-material/Login';
import { useDrawer } from '../../providers/DrawerProvider';

const CustomButton = styled(Button)(({theme}) => ({
  fontFamily: 'GothamBold !important',
  color: 'var(--black)',
  
  '&:hover': {
    backgroundColor: 'var(--gray-300)',
    boxShadow: 'none',
  },
}))

export const LoginButton = (props) => {
  const { setOpenDrawer, setFormPanel } = useDrawer();

  const drawerHandler = (method = 'register') => {
    setFormPanel(method);
    setOpenDrawer(true);
  }
  return (
    <CustomButton
      variant='text'
      size='small'
      onClick={props.drawer && (() => drawerHandler(props.drawer))}
      startIcon={<LoginIcon />}
    >
      Entrar
    </CustomButton>
  )
}
